import Avatar from 'boring-avatars';
import React from 'react';
import { imageUrl, classNames } from 'utils';
import './apps.scss';

export default function AppIcon({
  app,
  image,
  name,
  extension,
  extensionAssetType,
  size = 32,
  disabled = false,
}) {
  const appExtension = extension
    ? app?.extensions?.find((ext) => ext.id === extension)
    : null;

  const extensionIconImage = appExtension
    ? app.extension_assets?.find((asset) => asset.id === appExtension.id)?.[
        `${extensionAssetType}_icon_image`
      ]
    : null;

  const logoIcon =
    image ||
    (app?.type === 'theme'
      ? app.preview_mobile_image || app.preview_image
      : extensionIconImage
      ? extensionIconImage
      : app?.logo_icon);

  const appName = name || app?.name;

  return (
    <div
      className={classNames('apps-icon', { disabled })}
      style={{ width: size, height: size }}
    >
      {logoIcon?.url ? (
        <img
          src={imageUrl(logoIcon, { width: size * 2, height: size * 2 })}
          alt={appName || 'App'}
          style={{ width: size, height: size }}
        />
      ) : (
        <Avatar
          size={size}
          square={true}
          name={appName || 'App'}
          variant="marble"
          colors={['#A6B5FF', '#6881FD']}
        />
      )}
    </div>
  );
}
